import { render, staticRenderFns } from "./OuDetail.vue?vue&type=template&id=5805e348"
import script from "./OuDetail.vue?vue&type=script&lang=ts"
export * from "./OuDetail.vue?vue&type=script&lang=ts"
import style0 from "./OuDetail.vue?vue&type=style&index=0&id=5805e348&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports